import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { uniqueId } from 'lodash';

@Component({
  selector: 'aprova-checkbox',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent implements OnInit {
  @ViewChild('input', { static: false })
  public inputRef: ElementRef<HTMLInputElement> | undefined;

  @ViewChild('errorMessageRef', { static: true })
  public errorMessageRef: ElementRef<HTMLDivElement> | undefined;

  @Input()
  public id: string = uniqueId('aprova-checkbox-');

  @Input()
  public dataTestid?: string;

  @Input()
  public label: string = '';

  @Input()
  public color: string = '#06929F';

  @Input()
  public control: FormControl = new FormControl(false);

  @Input()
  public labelClass: string = 'block text-sm font-medium leading-6 text-gray-900';

  @Input()
  public checked: boolean = false;

  @Input()
  public readonly: boolean = false;

  @Input()
  public disabled: boolean = false;

  @Input()
  public required: boolean = false;

  @Input()
  public error: boolean = false;

  @Input()
  public errorMessages: Record<string, string> = {};

  @Output()
  public onChange = new EventEmitter<boolean>();

  get hasError(): boolean {
    if (this.error) return true;

    const someError = Object.values(this.control.errors || {}).some(Boolean);

    return (
      someError &&
      this.control.invalid &&
      (this.control.dirty || this.control.touched)
    );
  }

  get errorMessageInternal(): string {
    const key = Object.keys(this.control.errors || {}).find(Boolean);
    return key && this.errorMessages[key] ? this.errorMessages[key] : '';
  }

  get isErrorMessageSlotUsed(): boolean {
    return !!this.errorMessageRef?.nativeElement.innerHTML;
  }

  ngOnInit(): void {
    if (this.checked) {
      this.control.setValue(this.checked, { emitEvent: false });
    } else {
      this.checked = this.control.value;
    }
  }

  onInputChange(event: any): void {
    if (this.disabled) return;
    
    this.checked = event?.target?.checked ?? !this.checked;
    this.onChange.emit(this.checked);
    this.control.setValue(this.checked);
  }
}
